<template>
  <div id="unit-info" v-if="unit">
    <transition name="up-down" mode="out-in">
      <div v-if="hasInfo">
        <program-information v-if='unit && unit.description'></program-information>
        <career-opportunities
          v-if = 'unit.cip_code'
          :cip = 'unit.cip_code'
        >
        </career-opportunities>
        <hr v-if='unit && unit.point_of_contact'>
        <contact-information v-if='unit && unit.point_of_contact'></contact-information>
      </div>
      <div v-else>
        No additional program information.
      </div>
    </transition>
  </div>
</template>

<script>
  import CareerOpportunities from '../components/career_opportunities.vue'
  import ProgramInformation from '../components/program_information.vue'
  import ContactInformation from '../components/contact_information.vue'

  export default {
    name: 'UnitInfo',

    data() {
      return {
      }
    },

    computed: {
      unit() {
        return this.$store.state.unit
      },
      name() {
        return this.unit[this.unit.type].name
      },

      college() {
        return this.unit.college.name
      },

      hasInfo() {
        return this.unit.cip_code || this.unit.description || this.unit.point_of_contact
      }
    },

    components: {
      CareerOpportunities,
      ProgramInformation,
      ContactInformation
    }
  }
</script>



// WEBPACK FOOTER //
// UnitInfo.vue?6a0be0b8